import React, { useEffect } from 'react';

export function ServicesPage() {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('is-visible'); });
    }, { threshold: 0.1 });
    document.querySelectorAll('.animate-on-scroll').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="page-content">
      <section className="hero is-medium about-hero">
        <div className="hero-body">
          <div className="container has-text-centered">
            <p className="about-hero-label">WHAT WE OFFER</p>
            <h1 className="title is-2 has-text-white" style={{ fontWeight: 700, letterSpacing: "2px" }}>
              Esports Pricing <span style={{ color: "#6ee7b7" }}>Infrastructure</span>
            </h1>
            <p className="subtitle has-text-grey-light mt-3">
              Everything operators need to launch and scale esports betting markets
            </p>
          </div>
        </div>
      </section>

      {/* Core Service: Odds Feed */}
      <section className="section about-section">
        <div className="container">
          <div className="columns is-vcentered">
            <div className="column is-6 animate-on-scroll">
              <p style={{ color: "#E8655A", fontSize: "0.85rem", letterSpacing: "3px", fontWeight: 600 }}>CORE PRODUCT</p>
              <h2 className="title is-3 has-text-white mt-2">Esports Odds Feed</h2>
              <div className="content" style={{ color: "#c4c4c4" }}>
                <p>Real-time, simulation-driven odds across all major esports betting markets. Our Monte Carlo engine produces probabilities that update in sub-second, giving your traders and customers the most accurate prices available.</p>
                <ul>
                  <li>Series Winner</li>
                  <li>Correct Score</li>
                  <li>Map Winner</li>
                  <li>Over/Under Lines (kills, deaths, K/D)</li>
                  <li>Total Maps</li>
                  <li>Bet Builder with correlation handling</li>
                </ul>
              </div>
            </div>
            <div className="column is-6 animate-on-scroll" style={{ textAlign: "center" }}>
              <div className="service-feature-box">
                <i className="fa-solid fa-chart-line fa-4x mb-4" style={{ color: "#6ee7b7" }}></i>
                <p className="stat-number has-text-white">6+</p>
                <p className="stat-label">Markets per fixture</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Simulation Engine */}
      <section className="section" style={{ backgroundColor: "#252535" }}>
        <div className="container">
          <div className="columns is-vcentered">
            <div className="column is-6 animate-on-scroll" style={{ textAlign: "center" }}>
              <div className="service-feature-box">
                <i className="fa-solid fa-microchip fa-4x mb-4" style={{ color: "#E8655A" }}></i>
                <p className="stat-number has-text-white">100K</p>
                <p className="stat-label">Iterations per fixture</p>
              </div>
            </div>
            <div className="column is-6 animate-on-scroll">
              <p style={{ color: "#6ee7b7", fontSize: "0.85rem", letterSpacing: "3px", fontWeight: 600 }}>THE ENGINE</p>
              <h2 className="title is-3 has-text-white mt-2">Monte Carlo Simulation</h2>
              <div className="content" style={{ color: "#c4c4c4" }}>
                <p>Our game-specific simulation engine doesn't just crunch numbers — it models the actual mechanics of competitive play.</p>
                <ul>
                  <li>Game mode performance (Hardpoint, S&D, Overload)</li>
                  <li>Player-level stat simulation</li>
                  <li>Opposition-adjusted performance</li>
                  <li>LAN vs Online weighting</li>
                  <li>Recency-weighted player form</li>
                  <li>Series momentum and fatigue modelling</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* API & Integration */}
      <section className="section about-section">
        <div className="container">
          <div className="columns is-vcentered">
            <div className="column is-6 animate-on-scroll">
              <p style={{ color: "#E8655A", fontSize: "0.85rem", letterSpacing: "3px", fontWeight: 600 }}>INTEGRATION</p>
              <h2 className="title is-3 has-text-white mt-2">RESTful API & Distribution</h2>
              <div className="content" style={{ color: "#c4c4c4" }}>
                <p>Plug our pricing directly into your existing sportsbook platform. Our API handles the full lifecycle from fixture creation to price distribution.</p>
                <ul>
                  <li>RESTful API with JSON responses</li>
                  <li>Event-driven distribution via RabbitMQ</li>
                  <li>Sub-second pricing updates</li>
                  <li>Redis-cached simulation results</li>
                  <li>Flexible market configuration per game</li>
                  <li>Comprehensive API documentation</li>
                </ul>
              </div>
            </div>
            <div className="column is-6 animate-on-scroll" style={{ textAlign: "center" }}>
              <div className="service-feature-box">
                <i className="fa-solid fa-plug fa-4x mb-4" style={{ color: "#6ee7b7" }}></i>
                <p className="stat-number" style={{ color: "#6ee7b7" }}>&lt;1s</p>
                <p className="stat-label">Price delivery</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section has-text-centered" style={{ backgroundColor: "#252535" }}>
        <div className="container">
          <h2 className="title is-3 has-text-white">Ready to get started?</h2>
          <p className="has-text-grey-light is-size-5 mb-5">
            Request a demo and see our pricing engine in action.
          </p>
          <a href="/contact" className="button is-primary is-medium">Request Demo</a>
        </div>
      </section>
    </div>
  );
}
